module.exports = __webpack_public_path__ + "static/media/md-copy.1fde2908.svg";